import dayjs from 'dayjs';

const toCalendarDate = (date: dayjs.ConfigType): dayjs.Dayjs => {
  if (typeof date === 'string') {
    const isoDate = date.match(/^\d{4}-\d{2}-\d{2}/)?.[0];

    if (isoDate) {
      return dayjs(isoDate);
    }
  }

  return dayjs(date);
};

/**
 * @name getShippingEstimate
 */
export const getShippingEstimate = (
  earliestDate: dayjs.ConfigType,
  latestDate: dayjs.ConfigType
): string => {
  if (!earliestDate || !latestDate) {
    return '';
  }

  const earliest = toCalendarDate(earliestDate);
  const latest = toCalendarDate(latestDate);
  const latestFormat = 'D MMMM';

  const formattedEarliest = earliest.isSame(latest, 'month')
    ? earliest.format('D')
    : earliest.format(latestFormat);

  if (earliest.format('YYYY-MM-DD') === latest.format('YYYY-MM-DD')) {
    if (earliest.isSame(dayjs().add(1, 'd'), 'd')) {
      return `(Est. delivery tomorrow)`;
    }

    return `(Est. delivery ${latest.format(latestFormat)})`;
  }

  return `(Est. delivery ${formattedEarliest} - ${latest.format(latestFormat)})`;
};
